import { render, staticRenderFns } from "./ParamPos.vue?vue&type=template&id=0a9425b0"
import script from "./ParamPos.vue?vue&type=script&lang=ts"
export * from "./ParamPos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports